export const HIERARCHY_EMPHASIS_OPTIONS = [
  { value: "subtle", label: "Subtle contrast", description: "Keeps concept sizes closer together for compact maps and embeds." },
  { value: "balanced", label: "Balanced contrast", description: "Makes the hierarchy clear without dominating the map." },
  { value: "strong", label: "Strong contrast", description: "Creates pronounced size differences for presentations." },
];

export function normalizeHierarchyEmphasis(value) {
  return HIERARCHY_EMPHASIS_OPTIONS.some((option) => option.value === value)
    ? value
    : "balanced";
}

const PRESETS = {
  subtle: {
    focal: { width: 178, minHeight: 58, padding: 12, fontSize: 14, borderWidth: 2.5 },
    core: { width: 164, minHeight: 54, padding: 11, fontSize: 13, borderWidth: 2 },
    supporting: { width: 150, minHeight: 50, padding: 10, fontSize: 12, borderWidth: 1.5 },
    detail: { width: 142, minHeight: 46, padding: 9, fontSize: 11, borderWidth: 1 },
  },
  balanced: {
    focal: { width: 198, minHeight: 66, padding: 14, fontSize: 16, borderWidth: 3 },
    core: { width: 174, minHeight: 58, padding: 12, fontSize: 14, borderWidth: 2.25 },
    supporting: { width: 150, minHeight: 50, padding: 10, fontSize: 12, borderWidth: 1.5 },
    detail: { width: 134, minHeight: 44, padding: 8, fontSize: 10.5, borderWidth: 1 },
  },
  strong: {
    focal: { width: 220, minHeight: 76, padding: 16, fontSize: 18, borderWidth: 3.5 },
    core: { width: 190, minHeight: 64, padding: 13, fontSize: 15, borderWidth: 2.5 },
    supporting: { width: 150, minHeight: 50, padding: 10, fontSize: 12, borderWidth: 1.5 },
    detail: { width: 128, minHeight: 42, padding: 7, fontSize: 10, borderWidth: 1 },
  },
};

export function hierarchyNodeMetrics(importance, emphasis) {
  const preset = PRESETS[normalizeHierarchyEmphasis(emphasis)];
  return preset[importance] || preset.supporting;
}

export function hierarchyGapMultiplier(emphasis) {
  return { subtle: 0.9, balanced: 1, strong: 1.16 }[normalizeHierarchyEmphasis(emphasis)];
}
